import { render } from "./PrimaryButton.vue?vue&type=template&id=2d7600f0&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=2d7600f0&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7600f0"]])

export default __exports__